export default __webpack_public_path__ + "static/media/customer-icon.bf3c0639.svg";